import clsx from "clsx";
import { type FunctionComponent } from "react";
import type { PostListItem } from "~/database/post.model";
import PostItem from "./PostItem";
import PostItemText from "./PostItemText";
import useEmblaCarousel from "embla-carousel-react";
import Fade from "embla-carousel-fade";

import { useDotButton } from "./EmblaCarouselBar";
import { PR_COLORS } from "~/utils/const";

interface TopReccomendPostsProps {
  data: PostListItem[];
}

const TopReccomendPosts: FunctionComponent<
  TopReccomendPostsProps
> = ({ data }) => {
  const [emblaRef, emblaApi] = useEmblaCarousel(
    {
      loop: true,
    },
    [Fade()],
  );
  const { selectedIndex, onDotButtonClick } =
    useDotButton(emblaApi);

  return (
    <div className="">
      <div
        className={clsx(
          "w-1305",
          "mx-auto",
          "grid",
          "grid-cols-[1fr_auto]",
          "grid-rows-[auto_1fr]",
          "gap-x-70",
          "gap-y-40",
          "max-md:w-375",
          "max-md:block",
          "max-md:mr-0",
          "pb-80",
        )}
      >
        <div
          className={clsx(
            "col-start-1",
            "col-end-2",
            "row-start-1",
            "row-end-2",
          )}
        >
          <div
            className={clsx(
              "pl-28",
              "overflow-hidden",
              "max-md:pl-15",
            )}
          >
            <div
              className={clsx("pl-0", "embla")}
              ref={emblaRef}
            >
              <div className="embla__container">
                {data
                  .slice(0, 4)
                  ?.map((el, i) => {
                    return (
                      <div
                        className={clsx(
                          "embla__slide",
                        )}
                        key={i}
                      >
                        <PostItem
                          data={el}
                          type="large"
                          color={
                            PR_COLORS[
                              i % PR_COLORS.length
                            ]
                          }
                        ></PostItem>
                      </div>
                    );
                  })}
              </div>
            </div>
            <div
              className={clsx(
                "mt-14",
                "flex",
                "gap-5",
              )}
            >
              {data.slice(0, 4)?.map((el, i) => {
                return (
                  <div
                    key={i}
                    className={clsx(
                      "h-3",
                      "w-81",
                      "bg-gray-400",
                      "cursor-pointer",
                      "relative",
                      "max-md:w-70",
                    )}
                    onClick={() => {
                      onDotButtonClick(i);
                    }}
                  >
                    <div
                      className={clsx(
                        "absolute",
                        "h-full",
                        selectedIndex === i
                          ? "w-full"
                          : "w-0",
                        selectedIndex === i
                          ? "transition-all"
                          : "transition-none",
                        "duration-[4s]",
                        "ease-linear",
                        "left-0",
                        "top-0",
                        "bg-black",
                      )}
                    ></div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <div
          className={clsx(
            "w-360",
            "col-start-2",
            "col-end-3",
            "row-start-1",
            "row-end-3",
            "max-md:w-360",
            "max-md:ml-auto",
            "max-md:mt-50",
          )}
        >
          <ul
            className={clsx(
              "flex",
              "flex-col",
              "gap-40",
            )}
          >
            {data.slice(4, 7)?.map((el, i) => {
              return (
                <li key={i}>
                  <PostItem
                    color={
                      PR_COLORS[
                        i % PR_COLORS.length
                      ]
                    }
                    data={el}
                  ></PostItem>
                </li>
              );
            })}
          </ul>
        </div>
        <div
          className={clsx(
            "col-start-1",
            "col-end-2",
            "row-start-2",
            "row-end-3",
          )}
        >
          <h2
            className={clsx(
              "font-bold",
              "text-lg",
              "grid",
              "grid-cols-[auto_1fr_1fr]",
              "items-center",
              "pt-40",
              "gap-20",
              "max-md:grid-cols-[auto_3fr_1fr]",
              "max-md:text-20",
            )}
          >
            Recommend
            <div
              className={clsx("h-1", "bg-black")}
            ></div>
            <div className={clsx()}></div>
          </h2>
          <ul
            className={clsx(
              "grid grid-cols-3 gap-33",
              "mt-30",
              "max-md:flex",
              "max-md:flex-col",
              "max-md:gap-20",
            )}
          >
            {data.slice(7, 10)?.map((el, i) => {
              return (
                <li key={i}>
                  <PostItemText
                    data={el}
                  ></PostItemText>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default TopReccomendPosts;
